import type { Badge as BadgeType } from 'types/capi/newsArticle';

function getBackgroundColour(badge: BadgeType['colours']) {
  if (badge.primary && badge.secondary) {
    return `linear-gradient(to right, ${badge.primary}, ${badge.secondary})`;
  }

  return badge.primary || badge.secondary;
}

const Badge = ({ badge }: { badge: BadgeType | undefined }) => {
  if (!badge) return null;

  return (
    <div className="absolute bottom-0 left-3">
      <div
        className="px-4 py-2 text-sm font-bold uppercase tracking-[3px]"
        style={{
          background: getBackgroundColour(badge.colours),
          color: badge.colours.text
        }}
      >
        {badge.badge_type}
      </div>
    </div>
  );
};

export default Badge;
